import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import UpdateGroupProperties from './update_group_from';
import { useDispatch, useSelector } from 'react-redux';
import { GetMembersOfExceptGroup, getMembersOfGroup } from 'redux/slices/usersGroupSlice';
import { getUserInGroupData } from 'redux/slices/getUserInGroup';
import { getUserNotInGroupData } from 'redux/slices/getUserNotInGroup';
import { getChildOuDropdown, getDomainContainers } from 'redux/slices/getChildOu';

export default function UpdateGroup({ ...record }) {
  const dispatch = useDispatch();
  const selectedNode = useSelector((state) => state.selectedNode);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const [open, setOpen] = useState(false);
  const showModal = () => {
    let initialOuName = '';
    let fqdn = selectedNode.domainName ?? localStorage.getItem('domain');
    if (localStorage.getItem('role') === 'ouadmin') {
      initialOuName = adminOuName.dnName;
    } else {
      initialOuName =
        selectedNode.selectedNode && selectedNode.domainDn ? selectedNode.domainDn : localStorage.getItem('domainDn');
    }
    dispatch(
      getMembersOfGroup({ groupName: record.dnName, fqdn: selectedNode.domainName || localStorage.getItem('domain') })
    );
    dispatch(
      getChildOuDropdown({
        fqdn: fqdn,
        ouName: initialOuName,
      })
    );
    dispatch(getDomainContainers(fqdn));
    dispatch(
      GetMembersOfExceptGroup({
        groupName: record.dnName,
        fqdn: fqdn,
        ouName: initialOuName,
      })
    );
    dispatch(getUserInGroupData({ groupName: record.dnName, fqdn: selectedNode.domainName }));
    dispatch(
      getUserNotInGroupData({
        groupName: record.dnName,
        fqdn: selectedNode.domainName,
        ouName: initialOuName,
      })
    );
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip title='Update' color='#597081' className='af-group-edit-tooltip'>
        <SpanButton onClick={showModal} className='af-group-edit-tooltip-button'>
          <EditIcon className='af-group-edit-tooltip-icon' />
        </SpanButton>
      </Tooltip>
      {open && (
        <Modal
          width={800}
          open={open}
          className='modal-style af-group-edit-modal'
          maskClosable={false}
          onCancel={handleCancel}
          footer={[null]}
          centered
        >
          <UpdateGroupProperties {...record} handleCancel={handleCancel} />
        </Modal>
      )}
    </>
  );
}
